module.exports = __webpack_public_path__ + "static/media/ng01.f9425e6a.webp";